module.exports = __webpack_public_path__ + "static/media/1_A1_21.09162b5f.png";